export default __webpack_public_path__ + "static/media/dessert2.6ea4ac1c.png";